import { render } from "./media-blocks-new.vue?vue&type=template&id=b6146c5e"
import script from "./media-blocks-new.vue?vue&type=script&lang=js"
export * from "./media-blocks-new.vue?vue&type=script&lang=js"

import "./media-blocks-new.vue?vue&type=style&index=0&id=b6146c5e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__